import React, { useEffect, useState } from 'react';
import { Check } from '@material-ui/icons';
import { useIntl } from 'react-intl';
import { useBem } from '../../Bem';
import { QueryKey, useCurrentMeasurment, usePrevMeasurment } from '../helper';
import { useQueryClient } from 'react-query';
import GearIcon from '@material-ui/icons/SettingsRounded';
import Switch from '@material-ui/core/Switch';
import './MeasurementList.scss';
import { useField } from 'formik';
import { Popover } from '@material-ui/core';

const measurementData = {
  cm: {
    value: 'CM',
    coef: 1,
  },
  in: {
    value: 'Inches',
    coef: 2.54,
  },
};
type Props = {
  show: boolean;
};
export const MeasurementList = ({ show = false }: Props) => {
  const bem = useBem('switch-icon');
  const intl = useIntl();
  const queryClient = useQueryClient();
  const currentMeasurment = useCurrentMeasurment();
  const prevMeasurment = usePrevMeasurment();

  const [cameraHeight, metacameraHeight, cameraHeightHelper] = useField({ name: 'cameraHeight' });
  const [vehicleWidth, metaVehicleWidth, vehicleWidthHelper] = useField({ name: 'vehicleWidth' });
  const [cameraOffset, metaCameraOffset, cameraOffsetHelper] = useField({ name: 'cameraOffset' });

  const changeValue = (value: string, setter: { setValue: (value) => void; setTouched: (value: boolean) => void }) => {
    if (!isNaN(+value) && typeof +value === 'number' && prevMeasurment?.coef && currentMeasurment?.coef) {
      const coef = currentMeasurment.coef / prevMeasurment.coef;
      setter.setValue(Math.round(+value * coef).toString());
      setter.setTouched(false);
    }
  };

  return (
    <div className={bem
      .elem('box')
      .cls()}>
        <div>in</div>
          <div>
            <Switch
              checked={'CM' === currentMeasurment?.value}
              onChange={(e) => {
                let { value } = e.target;
                if (!e.target.checked) value = 'in';
                queryClient.setQueryData(QueryKey.prevMeasurment, currentMeasurment);
                queryClient.setQueryData(QueryKey.currentMeasurment, measurementData[value]);
                cameraHeight && changeValue(cameraHeight.value, cameraHeightHelper);
                vehicleWidth && changeValue(vehicleWidth.value, vehicleWidthHelper);
                cameraOffset && changeValue(cameraOffset.value, cameraOffsetHelper);
              }}
              value="cm"
              color="primary"
            />
          </div>
        <div>cm</div>
    </div>
  );
};
